import {
    terminateTaskPaneAddinCommand,
    getTaskPaneRunningInstance,
    TaskPaneType,
} from 'owa-addins-store';

export default function closeNonPersistentTaskPaneAddinCommand(hostItemIndex?: string) {
    const runningTaskPane = getTaskPaneRunningInstance(TaskPaneType.NonPersistent);
    if (!runningTaskPane || (hostItemIndex && runningTaskPane.hostItemIndex !== hostItemIndex)) {
        return;
    }

    terminateTaskPaneAddinCommand(TaskPaneType.NonPersistent);
}
